module.exports = __webpack_public_path__ + "img/KSC00022.5c814273.jpg";